import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { SharedMatchProgramService } from './shared-match-program.service';

@Component({
    selector: 'app-shared-match-program',
    templateUrl: './shared-match-program.component.html',
    styleUrls: ['./shared-match-program.component.scss'],
})
export class SharedMatchProgramComponent implements OnInit {
    registers;
    statusCode;
    description;

    vip: any;
    list = [];

    pauseTime = 3000;

    @Input() departmentType: string;

    @HostBinding('class.home') get h() {
        return !this.departmentType;
    }

    constructor(private sharedMatchProgramService: SharedMatchProgramService) {}

    ngOnInit(): void {
        this.getProgram();
    }

    getProgram() {
        this.sharedMatchProgramService
            .getProgram(this.departmentType)
            .subscribe((response) => this.successCallbackAPI(response));
    }

    successCallbackAPI(response) {
        this.registers = response.registers;
        this.statusCode = response.status_code;
        this.description = response.description;
        //console.log(response);
        this.vip = response.registers?.vip;
        this.list = response.registers?.list;
        // this.listFemale = response.registers?.list['2'] ? Object.values(response.registers.list['2']) : null;
    }
}
